import React, { useEffect, useState } from "react";
import "./Level.css";
import { db } from "../../App";
import { getDocs, collection, query, where } from "firebase/firestore";

function Container(props) {
  let levelNum = window.location.href.split("/")[4];

  let [option, setOption] = useState();
  let propObject = props.Object;
  let nomor = props.Object.nomor;
  let nextForm = document.querySelector(`.form-qna.no-${parseInt(nomor) + 1}`);

  const handleNext = () => {
    let currentForm = document.querySelector(`.form-qna.no-${nomor}`);

    if (nextForm) {
      currentForm.style.display = "none";
      nextForm.style.display = "flex";
    }

    if (!nextForm) {
      window.location.href = `/hasil/${levelNum}`;
      return;
    }
  };

  const handlePopup = (e) => {
    if (!option) {
      let ErrorHtml = document.querySelector(`.Error`);
      ErrorHtml.style.display = "block";
      return;
    } else {
      let ErrorHtml = document.querySelector(`.Error`);
      ErrorHtml.style.display = "none";
    }

    let overlay = document.querySelector(`.overlay.no-${nomor}`);
    let title = document.querySelector(`.title.no-${nomor}`);
    let kunci = document.querySelector(`.kunci.no-${nomor}`);
    let next = document.querySelector(`.lanjut-level.no-${nomor}`);
    let returnButton = document.querySelector(`.kembali.no-${nomor}`);
    let lanjut = document.querySelector(`.lanjut-nomor.no-${nomor}`);

    props.Object.Correct + `_${nomor}` === option
      ? (title.innerText = "Jawaban Anda Benar!")
      : (title.innerText = "Jawaban Anda Salah!");

    if (nextForm) {
      next.style.display = "none";
      next.style.opacity = "0";
      next.style.visibility = "hidden";

      kunci.style.display = "none";
      kunci.style.opacity = "0";
      kunci.style.visibility = "hidden";

      returnButton.style.display = "none";
      returnButton.style.opacity = "0";
      returnButton.style.visibility = "hidden";
    }

    if (!nextForm) {
      next.style.display = "block";
      next.style.opacity = "1";
      next.style.visibility = "visible";

      kunci.style.display = "block";
      kunci.style.opacity = "1";
      kunci.style.visibility = "visible";

      returnButton.style.display = "block";
      returnButton.style.opacity = "1";
      returnButton.style.visibility = "visible";

      lanjut.style.display = "none";
    }

    overlay.style.visibility = "visible";
    overlay.style.opacity = "1";
  };

  const closePopup = (e) => {
    let overlay = document.querySelector(`.overlay.no-${nomor}`);
    let next2Form = document.querySelector(
      `.form-qna.no-${parseInt(nomor) + 2}`
    );

    overlay.style.visibility = "hidden";
    overlay.style.opacity = "0";

    if (!next2Form) {
      document.querySelector(`.hover.btn-no${parseInt(nomor) + 1}`).innerHTML =
        "Selesai →";

      document.querySelector(`.text.btn-no${parseInt(nomor) + 1}`).innerHTML =
        "Selesai";
    }

    handleNext();
  };

  const handleSubmit = (form) => {
    form.preventDefault();

    if (!option) {
      let ErrorHtml = document.querySelector(`.Error.no-${nomor}`);
      ErrorHtml.style.display = "block";
      return;
    } else {
      let ErrorHtml = document.querySelector(`.Error.no-${nomor}`);
      ErrorHtml.style.display = "none";
    }

    let userOption = option.split("_")[0];

    localStorage.setItem(
      `Level${levelNum}_no${nomor}`,
      JSON.stringify({
        userOption: userOption,
        correctOption: props.Object.Correct,
        true: props.Object.Correct === userOption,
      })
    );
  };

  const handleChange = (e) => {
    setOption(e.target.id);
  };

  return (
    <form
      className={`form-qna no-${props.Object.nomor}`}
      onSubmit={handleSubmit}
      style={{ display: "none" }}
    >
      <p className="Question">
        {propObject.nomor}. {props.Object.Question}
      </p>
      <div className="Answers">
        <ul className="list">
          {React.Children.toArray(
            props.Object.Option.map((dat) => (
              <div className={`Answer`}>
                <input
                  className={`radio-btn ${dat.option}`}
                  type="radio"
                  id={`${dat.option}_${props.Object.nomor}`}
                  name={props.Object.nomor}
                  value={`${dat.option}_${props.Object.nomor}`}
                  onChange={handleChange}
                />
                <label
                  className={`label ${dat.option}`}
                  htmlFor={`${dat.option}_${props.Object.nomor}`}
                >
                  {dat.answer}
                </label>
              </div>
            ))
          )}
        </ul>
      </div>

      <p
        className={`Error no-${nomor}`}
        style={{ color: "red", display: "none" }}
      >
        Silahkan pilih jawaban terdahulu
      </p>

      <button className={`top btn-no${nomor} next-btn`} onClick={handlePopup}>
        <span className={`text btn-no${nomor}`}>Lanjut</span>
        <span className={`hover btn-no${nomor}`}>Lanjut &rarr;</span>
      </button>

      <div className={`overlay no-${nomor}`}>
        <div className="popup">
          <h2 className={`title no-${nomor}`}>Jawaban anda benar!</h2>

          <div className="btn-wraps">
            <a className={`lanjut-nomor no-${nomor}`} onClick={closePopup}>
              Lanjut
            </a>
          </div>
          <div className="btn-wraps">
            <a
              className={`kunci no-${nomor}`}
              style={{
                visibility: "hidden",
                opacity: "0",
                display: "none",
              }}
              href={`/kunci/${levelNum}`}
            >
              Kunci Jawaban
            </a>
            <a
              className={`lanjut-level no-${nomor} pop-btn`}
              style={{ visibility: "hidden", opacity: "0", display: "none" }}
              href={`/level/${parseInt(levelNum) + 1}`}
            >
              Lanjut Level
            </a>

            <a
              className={`kembali no-${nomor}`}
              style={{
                visibility: "hidden",
                opacity: "0",
                display: "none",
              }}
              href={`/level`}
            >
              Kembali
            </a>
          </div>
        </div>
      </div>
    </form>
  );
}

function Level(porps) {
  let levelNum = window.location.href.split("/")[4];

  const getActualQuestion = async () => {
    const q = query(collection(db, "question"), where("level", "==", levelNum));
    const querys = await getDocs(q);
    let tempArray = [];

    querys.forEach((element) => {
      tempArray.push(element.data());
    });

    return new Promise((resolve, reject) => {
      resolve(Promise.resolve(tempArray));
    });
  };

  let [Question, setQuestion] = useState([
    {
      Question: "Preload Question",
      nomor: "1",
      Option: [
        { answer: "Preload answer A", option: "A" },
        { answer: "Preload answer B", option: "B" },
        { answer: "Preload answer C", option: "C" },
        { answer: "Preload answer D", option: "D" },
      ],
    },
  ]);

  useEffect(() => {
    getActualQuestion().then((data) => {
      setQuestion(data);
      if (data.length < 1) {
        window.location.href = "/level";
      }
    });
  }, []);

  if (document.readyState === "complete") {
    let container = document.querySelector(`.form-qna.no-1`);
    container.style.display = "flex";
  }

  return (
    <div>
      <p className="lvlCount">Level {levelNum}</p>
      <div className="Container">
        {React.Children.toArray(
          Question.sort((a, b) => a.nomor - b.nomor).map((data) => (
            <Container Object={data}></Container>
          ))
        )}
      </div>
      <div className="circle"></div>
      <div className="diamond"></div>
    </div>
  );
}

export default Level;
